// extracted by mini-css-extract-plugin
module.exports = {"root":"index__root___21mbC","icon":"index__icon___2D3_E"};